import React from 'react';
import PropTypes from 'prop-types';

const SeatMobileIcon = ({ className, color }) => (
  <svg
    className={className}
    width='14px'
    height='24px'
    viewBox='0 0 14 24'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <g
      id='1-copy-23'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
      transform='translate(-318.000000, -610.000000)'
      opacity='1'
    >
      <g id='seat_img' transform='translate(318.000000, 610.000000)'>
        <polygon id='Clip-2' points='2.625 5.33333333 14 5.33333333 14 24 2.625 24' />
        <path
          d='M13.9943473,18.7019303 C13.9943473,19.8594862 14.0095044,21.0174397 13.9901791,22.1747969 C13.9706644,23.3299678 13.4197039,24.004745 12.5457079,23.9999749 C11.6569337,23.995006 11.1684963,23.3609738 11.1703909,22.1390208 C11.1726645,20.6513308 11.15656,19.1598645 11.2516708,17.6771434 C11.3107835,16.7578961 10.979222,16.5462208 10.1806325,16.5833882 C8.95347614,16.6402325 7.7219621,16.6078352 6.49234268,16.591736 C4.92149915,16.5710653 4.17065451,15.9507473 3.84686105,14.3428098 C3.4306093,12.2743543 3.04599799,10.1987436 2.67199665,8.12134404 C2.43516702,6.80557816 3.11098404,5.71261796 4.3032791,5.40573842 C5.47643833,5.10343028 6.57570671,5.76349954 6.89135324,7.09178706 C7.27179635,8.69316556 7.57493826,10.3168048 7.85079741,11.9418352 C7.96087582,12.5907742 8.2109679,12.8328592 8.83979792,12.8012569 C9.75187617,12.7553443 10.6681226,12.7823751 11.582285,12.8002632 C13.1667699,12.8312691 13.9077624,13.5817724 13.9475498,15.2292624 C13.975401,16.3860233 13.9528548,17.5443743 13.9528548,18.7019303 L13.9943473,18.7019303 Z'
          id='Fill-1'
          fill={color}
          fillRule='nonzero'
        />
        <path
          d='M5.28513301,19.5509722 C3.34505413,19.5128401 1.75548912,18.2910569 1.26375318,16.2737528 C0.775829151,14.2722073 0.424952234,12.2317516 0.0292400358,10.2049144 C-0.108896195,9.49830351 0.255594674,9.04266398 0.844261948,8.91406547 C1.51316078,8.76795732 1.83372396,9.27865491 1.95897232,9.90569428 C2.28734084,11.5512106 2.59937261,13.2004233 2.90922615,14.8500252 C3.23922834,16.607214 4.04771556,17.327249 5.73348582,17.338533 C6.64017501,17.3447586 7.54704572,17.3393112 8.45373491,17.3430077 C9.11246865,17.3457314 9.59930357,17.6272473 9.6239902,18.3904727 C9.65031051,19.2064216 9.15948217,19.5317116 8.45863593,19.5480539 C7.88467172,19.561478 7.31016296,19.5509722 6.73583571,19.5515559 C6.25226815,19.5523341 5.76851906,19.5605052 5.28513301,19.5509722 Z'
          id='Fill-4'
          fill={color}
          fillRule='nonzero'
        />
        <path
          d='M3.99712686,0.000446714722 C5.16225667,-0.0243015832 6.21180368,0.982710147 6.24901067,2.16069427 C6.28587314,3.32368999 5.28748573,4.3901325 4.11305417,4.44259192 C2.96893941,4.49383135 1.91646407,3.47496832 1.87615651,2.27711584 C1.83636571,1.09059181 2.82889646,0.0251950127 3.99712686,0.000446714722'
          id='Fill-6'
          fill={color}
          fillRule='nonzero'
        />
      </g>
    </g>
  </svg>
);
SeatMobileIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

export default SeatMobileIcon;



// WEBPACK FOOTER //
// ./src/icons/SeatMobileIcon.js